export const webActionTypes = {
    URL_REDIRECTION: 'url_redirection',
    PHONE: 'phone',
};
export const appLinkTypes = {
    CATEGORY: 'category',
    PRODUCT: 'product_id',
    LANDING: 'landing_page',
};
